import React from "react";
import { useSelector } from "react-redux";
import { LANDSCAPE } from "../../config/Constant";
import WelcomeScreen_landscape from "./welcomeScreen_landscape";
import WelcomeScreen_potrait from "./welcomeScreen_potrait";




export const WelcomeScreen = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    if (appOrientation == LANDSCAPE) {
        return <WelcomeScreen_landscape {...props} />;
    } else {
        return <WelcomeScreen_potrait {...props} />;
    }
}

